import Fetch from '../../util/_fetch';
import { useQuery } from '@tanstack/react-query';
import {
  AssetParams,
  Brand,
  createUrl,
  defaultResponseHandler,
  useAssetParams,
  useAssetTranslation,
} from '@mss/mss-component-library';

function useBrandsQuery(overrideAssetParams?: Partial<AssetParams>) {
  const { assetType, assetSubType } = useAssetParams(overrideAssetParams);
  const url = createUrl(
    { assetType },
    `brands/?series__type=${assetSubType}`,
    true
  );
  const { t } = useAssetTranslation();

  return useQuery({
    queryKey: [assetType, 'brands', assetSubType],
    initialData: [],
    initialDataUpdatedAt: 0,
    queryFn: async () =>
      (
        await defaultResponseHandler<Brand[]>({
          t,
          request: Fetch.get(url),
        })
      ).data ?? [],
  });
}

export default useBrandsQuery;
